export enum VerificationStep {
  CONTACTS_INPUT = 'contacts_input',
  CODES_VERIFICATION = 'codes_verification',
}
